export const MODULE_NAME = 'modal';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    ADDED_MESSAGE: `${prefix}ADDED_MESSAGE`,
    DISMISSED_FIRST_MESSAGE: `${prefix}DISMISSED_FIRST_MESSAGE`,
    CLEAR_MESSAGES: `${prefix}CLEAR_MESSAGES`
};
